import axios from 'axios'
import Qs from 'qs'
import Message from 'ant-design-vue/lib/message'
import 'ant-design-vue/lib/message/style/index.css'
import router from '@/router/index'
let HTTP;

export function createAPPAxiosInstance(app) {
    let headers = {
        appid: app.$APPID,
        token: app.$APPCFG.token,
    }
    if(localStorage.getItem('lang') == 'en') {
        headers = {
            ...headers,
            'htpailang': 'english'
        }
    }

    const axiosInstance = axios.create({
        baseURL: app.$BASE_URL,
        timeout: 200000,
        headers
    })
    axiosInstance.interceptors.request.use(function (config) {
        config.headers.time = Date.parse(new Date()) / 1000
        config.headers.mtoken = localStorage.mtoken;
        
        if (localStorage.mtoken && config.method == 'get') {
            if (!config.params) {
                config.params = {}
            }
            config.params.mtoken = localStorage.mtoken
        }
        if (config.method == 'post' && config.data && config.data && config.headers['Content-Type'] !== 'multipart/form-data') {
            config.data = Qs.stringify(config.data)
            if (localStorage.recode) {
                config.data += '&recode=' + localStorage.recode
            }
            if (localStorage.mtoken) {
                config.data += '&mtoken=' + localStorage.mtoken
            }
        }
        if((!config.params || !config.params.noloading) && (config.data && JSON.stringify(config.data).indexOf('noloading') === -1)){
            Message.loading("Loading...", 0);
        }
        return config
    }, function (error) {
        console.log('axios request error:' + error)
    })

    axiosInstance.interceptors.response.use(function (response) {
        Message.destroy();
        if(response.data.code == -50) {
            router.push({path:'/login'});
        }
        return response
    }, function (error) {
        console.log('axios response error:' + error)
    })
    HTTP = axiosInstance;
    return axiosInstance
}

export {HTTP};
